<template>
  <CCard>
    <CCardHeader>
      <CIcon name="cil-map"/>
      Localisation
      <!--
      <a 
        href="https://coreui.io/pro/vue/" 
        rel="noreferrer noopener" 
        target="_blank" 
        class="badge badge-danger 
        ml-1"
      >-->
        - Dernière transmission
      </a>
      <!--
      <div class="card-header-actions">
        <a 
          href="https://github.com/xkjyeah/vue-google-maps" 
          rel="noreferrer noopener" 
          target="_blank" 
          class="card-header-action"
        >
          <small class="text-muted">docs</small>
        </a>
        -->
      </div>
    </CCardHeader>
    <CCardBody>  
      <GmapMap
        :center="center"
        :zoom="6"
        style="height: 600px"
      >
        <GmapInfoWindow :options="infoOptions" 
              :position="infoWindowPos" 
              :opened="infoWinOpen" @closeclick="infoWinOpen=false">
              <div id="content">
                <div id="siteNotice"></div>
                <a v-bind:href="infoLink" target="_blank" ><b>{{infoContent1}}</b></a><br> 
                <a>{{infoContent2}}</a><br>
                <a>{{infoContent3}}</a>
                </div>
        </GmapInfoWindow>
        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :label="m.label"
          :title="m.title"
          :clickable="true"
          :draggable="m.draggable"
          @click="toggleInfoWindow(m, index)"
        >        
        <GmapPolyline
        :path="location.path"
        >
      </GmapMarker>
    </GmapMap>
    </CCardBody>
  </CCard>
</template>
 



<script>

const APIURL = process.env.VUE_APP_API_URL

import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from 'vue'
import axios from 'axios'

Vue.use(VueGoogleMaps, {
  load: {
 //  key: 'AIzaSyAlZMX-BNzJ8EvLsxBP5IjFGQEEKMjqlok',   // quantiumsys  old (for dev)
  key: 'AIzaSyAcZURn-nOdnJMYq4h8OJ0UwQ-uxMbJ4J4',   // quantiumsys 
 
    // key: ''
    // To use the Google Maps JavaScript API, you must register your app project on the Google API Console and get a Google API key which you can add to your app
    // v: 'OPTIONAL VERSION NUMBER',
    // libraries: 'places', //// If you need to use place input
          // Demonstrating how we can customize the name of the components
   //   installComponents: false,
  }
})


export default {
  name: 'google-maps',
  data () {
    // 46.7797673,-71.2711541,
    return {
      center:{lat: 46.7797673, lng: -71.2711541},
      markers: [
        {
        position: {lat: 46.7812, lng: -71.278},
        label: 'HQ',
        draggable: false, 
        content: 'Sentielle Nord',
        www: 'https://sentinellenord.ulaval.ca/',       
        }
        ],  
      location: { 
        path: [  
          // { lat:37.772, lng:-122.214}, {lat:21.291,lng:-157.821},{lat:-18.142,lng:178.431},{lat:-27.467,lng:153.027} 
        ] 
        },      
      infoContent1: '',
      infoContent2: '',
      infoContent3: '',
      infoLink: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      // optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    }
  },
  computed: 
  {

  },
  mounted()
  {
      // Get param
      if (this.$route.query != null)
      {
          if (this.$route.query.lat != null)
              this.center.lat = parseFloat (this.$route.query.lat )
          if (this.$route.query.lng != null)
              this.center.lng = parseFloat( this.$route.query.lng )
      }

      var addId=""

      // single message?
      if (this.$route.query.id != null)
          addId = "&id="+this.$route.query.id
      
      {          
        // some time the filter is not uptodate => this add the same delay that the header page => ugly but works
        {
          
            axios.get( APIURL+'/api1/devices', {   
              mode: 'no-cors',
                    headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                  },
                withCredentials: false
              } )
              .then(  res => { 
                console.log('finally imei ='+res)
              }  )
              .catch( err => console.log(err))
              .finally(() => {
                  
                      function sortedMsgArray(a, b) {
                        if (a.imei < b.imei)
                          return -1;
                        if (a.imei > b.imei)
                          return 1;
                        if (a.time < b.time)
                          return -1;
                        if (a.time > b.time)
                          return 1;
                        return 0;
                      }

                    console.log('SN messages mounted() imei='+this.$store.state.filterDevicesIMEI)
                    var addIMEI="",addDateFrom="",addDateTo=""
                    if (addId.length<=0)
                    {
                        addIMEI='&imei='+this.$store.state.filterDevicesIMEI
                        console.log('finally imei store='+this.$store.state.filterDevicesIMEI)
                        var d=this.$store.state.filterDateStart
                        addDateFrom='&dateFrom='+(d.getFullYear())+'-'+(d.getMonth()+1)+'-'+(d.getDate())
                        d=this.$store.state.filterDateEnd
                        addDateTo='&dateTo='+(d.getFullYear())+'-'+(d.getMonth()+1)+'-'+(d.getDate())
                    }
              
                    axios.get( APIURL+'/api1/messages?direction=MO'+addId+addDateFrom+addDateTo+addIMEI, {   
                        mode: 'no-cors',
                              headers: {
                              Accept: 'application/json',
                              'Content-Type': 'application/json',
                            },
                        withCredentials: false
                      } )
                      .then( res => { 
                       //   console.log("map message START :");
                      //    console.log("map message start unsorted :", res.data);
                          res.data = res.data.sort(sortedMsgArray);
                     //     console.log("map message start sorted:", res.data);

                          for (var x=0; x< res.data.length; x++)
                          {
                              var dmsg = this.$SNConvPayload( res.data[x].payload )
                              if (dmsg == null) 
                                 console.log('SNmaps(): mounted:',null);
                              else {
                                this.markers.push( 
                                {
                                    position: {lat: dmsg.lattitude, lng:  dmsg.longitude},
                                    label: res.data[x].providerName,
                                    draggable: false,
                                    content: this.$SNFormatDate( dmsg.time ) + '\nlat:'+dmsg.lattitude.toFixed(7)+'\nlng: '+dmsg.longitude.toFixed(7)+'\n',
                                    www: '/#/SN/SNmessages?id='+res.data[x]._id+"&tok="+parseInt(Date.now())  
                                } )
                                if (this.$store.state.selectedDeviceIMEI == res.data[x].imei)
                                {
                                  this.location.path.push( 
                                  {
                                      lat: dmsg.lattitude, 
                                      lng: dmsg.longitude 
                                  } )
                                }
                              }
                          }
                  //        console.log("map message end :", res.data);
                  //        console.log("map message end :");

                        }     
                        )
                      .catch( err => console.log(err))
                      .finally(() => {
                          this.loading = false
                        }
                      )
                  }                  
              )
        }
      }
  },
  methods: {
    toggleInfoWindow (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent1 = marker.content.split('\n')[0]
      this.infoContent2 = marker.content.split('\n')[1]
      this.infoContent3 = marker.content.split('\n')[2]
      this.infoLink = marker.www
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        // if different marker set infowindow to open and reset current marker index
        this.currentMidx = idx
        this.infoWinOpen = true
      }
    }
  }
}
</script>
